import React from 'react';
import glamorous from 'glamorous';
import theme from '../../theme';

const { scale, colors, icons } = theme;
const { white, black, pink, blue, grey } = colors;

const mapScale = val =>
  typeof val === 'string' ? val : val.map(unit => scale[unit]).join(' ');

const mapColor = (color, defaultColor = black) =>
  color === 'white'
    ? white
    : color === 'pink' ? pink : color === 'blue' ? blue : defaultColor;

// anything that uses this Div will accept props to create styles
export const Div = glamorous('div')(
  { borderSizing: 'border-box' },
  ({
    p = [0],
    m = [0],
    bg,
    color,
    shadow,
    width = 'auto',
    height = 'auto',
    maxWidth = 'auto',
    minWidth = 0,
    minHeight = 0,
    display = 'block',
    textAlign = 'left'
  }) => {
    return {
      // border: '1px solid #000', // grid everything out
      margin: mapScale(m),
      padding: mapScale(p),
      backgroundColor: mapColor(bg, 'transparent'),
      color: mapColor(color),
      width,
      height,
      maxWidth,
      minWidth,
      minHeight,
      display,
      borderRadius: '2px',
      textAlign,
      boxShadow: shadow
        ? '0 4px 8px 0 rgba(72, 72, 72, 0.1), 0 6px 20px 0 rgba(72, 0, 0, 0.1)'
        : 0
    };
  }
);

export const Span = glamorous('span')(({ p = [0], m = [0], color, width = 'auto' }) => {
  return {
    width,
    margin: mapScale(m),
    padding: mapScale(p),
    color: mapColor(color)
  };
});

export const Flex = glamorous(Div)(
  { display: 'flex' },
  ({
    direction = 'row',
    alignItems = 'strech',
    justifyContent = 'flex-start',
    flexWrap = 'no-wrap',
    flex = '0 1 auto'
  }) => ({
    flexDirection: direction,
    alignItems,
    justifyContent,
    flexWrap,
    flex
  })
);

export const CenterY = glamorous(Flex)({
  flexDirection: 'column',
  justifyContent: 'center'
});

export const Button = glamorous('button')(({ p = [2], neutral }) => {
  return {
    border: 'none',
    padding: mapScale(p),
    color: white,
    backgroundColor: neutral ? grey : blue,
    borderRadius: '2px',
    fontSize: '12px'
  };
});

export const HeaderButton = glamorous(Button)(({ bg = 'white' }) => ({
  padding: mapScale([1, 2]),
  fontWeight: 100,
  backgroundColor: mapColor(bg)
}));

export const LightText = glamorous(Span)(({ fontSize = '1em', p = [0] }) => ({
  color: grey,
  padding: mapScale(p),
  fontSize
}));

// icons
export const PlaneIcon = glamorous(icons.plane)({ color: blue });
export const ChevronLeft = glamorous(icons.chevronLeft)({ color: black });
export const ChevronRight = glamorous(icons.chevronRight)({ color: black });
export const CalendarIcon = glamorous(icons.calendar)({ color: black, size: '10px' });
export const InfoIcon = glamorous(icons.info)({ color: white, fontSize: '22px' });
export const SearchIcon = glamorous(icons.search)({ color: white, fontSize: '22px' });
export const SortIcon = glamorous(icons.sort)({ color: black });
export const CheckedOnIcon = glamorous(icons.checkedOn)({
  color: pink,
  fontSize: '22px'
});
export const CheckedOffIcon = glamorous(icons.checkedOff)({
  color: black,
  fontSize: '22px'
});
export const ExternalLinkIcon = glamorous(icons.externalLink)({
  color: white,
  fontSize: '16px'
});

export const OvercastIcon = props =>
  <span>
    <img src={icons.overcast} width="100px" alt="cloud" />
  </span>;



// WEBPACK FOOTER //
// ./src/components/hocs/withStyles.js